import { CallStateEnum } from '@models/call-state.model.ts';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';
import {
  CurrenciesModel,
  PmsConfigResponse,
  ProfileModel
} from '@models/profile.model.ts';

export type HandleClose = () => void;

export interface OrganizationInfoParams {
  data?: any;
  id?: number;
  handleClose?: HandleClose;
}

export interface ProfileState extends CallStateMethods {
  callState: CallStateEnum;
  organizationInfoCallState: CallStateEnum;
  organizationBrandingCallState: CallStateEnum;
  uploadImageCallState: CallStateEnum;
  profileData: ProfileModel;
  selectedCurrency: CurrenciesModel | null;
  currencies: CurrenciesModel[];
  pmsConfigCallState: CallStateEnum;
  activePmsConfig: PmsConfigResponse | null;
  getProfile: () => void;
  getCurrencies: () => void;
  getPmsConfig: () => Promise<void>;
  isPmsConfigLoading: () => boolean;
  editOrganizationInfo: (params: OrganizationInfoParams) => void;
  organizationBranding: (params: OrganizationInfoParams) => void;
  uploadAvatar: (body: { avatar: string }) => void;
  previewUrl: string | null;
  setPreviewUrl: (url: string | null) => void;
  isOrganizationInfoLoading: () => boolean;
  isOrganizationInfoError: () => boolean;
  isOrganizationInfoLoaded: () => boolean;
  isUploadImageLoading: () => boolean;
  isUploadImageError: () => boolean;
  isUploadImageLoaded: () => boolean;
  isOrganizationBrandingLoading: () => boolean;
  isOrganizationBrandingLoaded: () => boolean;
  isOrganizationBrandingError: () => boolean;
}

interface ProfileStateMethods extends CallStateMethodNames {
  getProfile: 'getProfile';
  getPmsConfig: 'getPmsConfig';
  isPmsConfigLoading: 'isPmsConfigLoading';
  getCurrencies: 'getCurrencies';
  uploadAvatar: 'uploadAvatar';
  editOrganizationInfo: 'editOrganizationInfo';
  setPreviewUrl: 'setPreviewUrl';
  isOrganizationInfoLoading: 'isOrganizationInfoLoading';
  organizationBranding: 'organizationBranding';
  isOrganizationInfoLoaded: 'isOrganizationInfoLoaded';
  isOrganizationInfoError: 'isOrganizationInfoError';
  isUploadImageLoading: 'isUploadImageLoading';
  isUploadImageError: 'isUploadImageError';
  isUploadImageLoaded: 'isUploadImageLoaded';
  isOrganizationBrandingLoading: 'isOrganizationBrandingLoading';
  isOrganizationBrandingLoaded: 'isOrganizationBrandingLoaded';
  isOrganizationBrandingError: 'isOrganizationBrandingError';
}

export const PROFILE_INITIAL_STATE: Omit<
  ProfileStateMethods,
  keyof ProfileState
> = {
  profileData: null,
  previewUrl: null,
  selectedCurrency: null,
  currencies: [],
  activePmsConfig: null,
  pmsConfigCallState: CallStateEnum.Loading,
  organizationInfoCallState: CallStateEnum.Init,
  organizationBrandingCallState: CallStateEnum.Init,
  uploadImageCallState: CallStateEnum.Init,
  callState: CallStateEnum.Init
};
